import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import './App.css';
import {
  AlertContextProvider,
  FeatureContextProvider,
  RoleOpContextProvider,
  UserContextProvider,
  theme,
} from './common';
import { ThemeProvider } from '@mui/material';
import { LandingRoutes } from './LandingRoutes';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AlertContextProvider>
        <UserContextProvider>
          <FeatureContextProvider>
            <RoleOpContextProvider>
              <BrowserRouter basename="csos2">
                <LandingRoutes />
              </BrowserRouter>
            </RoleOpContextProvider>
          </FeatureContextProvider>
        </UserContextProvider>
      </AlertContextProvider>
    </ThemeProvider>
  );
}

export default App;
